import { useEffect, type ReactNode } from "react";
import { cn } from "../tokens";

/** Modal accesible con cierre por Escape y clic en el fondo. */
export function Modal({ open, onClose, ariaLabel, widthClass, children }:
  { open: boolean; onClose: () => void; ariaLabel?: string; widthClass?: string; children: ReactNode }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div role="dialog" aria-modal="true" aria-label={ariaLabel}
        className={cn("relative max-h-[90vh] overflow-y-auto rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-container)] shadow-xl",
          widthClass ?? "w-[min(520px,92vw)]")}>
        <button type="button" onClick={onClose} aria-label="Cerrar"
          className="absolute right-3 top-3 z-10 flex h-7 w-7 items-center justify-center rounded text-[var(--color-on-surface-variant)] hover:bg-[var(--color-surface-variant)] hover:text-[var(--color-on-surface)]">✕</button>
        {children}
      </div>
    </div>
  );
}
